//5、6矩形圆角缺A
import makerjs from "makerjs";
//已知弧的两个端点 以及半径，求圆心坐标
//已知圆上两个点坐标及圆的半径，求圆心坐标函数
function Circle_Center(x1, y1, x2, y2, r) {
   var a = 0, b = 0, b2 = 0;
   console.log("Circle_Center计算圆心坐标函数")
   console.log("x1, y1, x2, y2, r",x1, y1, x2, y2, r);
   //Math.pow((x1-a),2)+Math.pow((y1-b),2) == Math.pow(r,2)
   //Math.pow((x2-a),2)+Math.pow((y2-b),2) == Math.pow(r,2)
   var c1 = (x2 * x2 - x1 * x1 + y2 * y2 - y1 * y1) / (2 * (x2 - x1));
   var c2 = (y2 - y1) / (x2 - x1);//
   var A = (c2 * c2 + 1);
   var B = (2 * x1 * c2 - 2 * c1 * c2 - 2 * y1);
   var C = x1 * x1 - 2 * x1 * c1 + c1 * c1 + y1 * y1 - r * r;
   b = (-B + Math.sqrt(B * B - 4 * A * C)) / (2 * A);
   b2 = (-B - Math.sqrt(B * B - 4 * A * C)) / (2 * A);
   a = c1 - c2 * b;
   var arr = [a, b, b2];
   console.log("arr==", arr);
   return arr; 
 };
// 矩形等去角 连线函数
function creatmyRectRoundGapA(area, param) {
   console.log("是否调用此函数creatOneCorner（）");
   console.log("是否调用此函数creatOneCorner（）param=", param);
   var xa = param.xa, ya = param.ya, xb = param.xb, yb = param.yb, xc = param.xc, yc = param.yc, 
       xd = param.xd, yd = param.yd, xe = param.xe, ye = param.ye, xf = param.xf, yf = param.yf,
      xg = param.xg, yg = param.yg, xh = param.xh, yh = param.yh, xi = param.xi, yi = param.yi,
      x0 = param.x0, y0 = param.y0, 
      //x0, y0, w,w1,w2,h,h1,h2, r,r1,r2,gxah,gxaw,gxch,gxcw,gxgh,gxgw,gxih,gxiw,gyah,gyaw,gych,
      //gycw,gygh,gygw,gyih,gyiw, xa, ya, xb, yb, xc, yc,xd, yd,xe, ye,xf, yf, xg, yg, xh, yh, xi, yi
      w = param.w,w1 = param.w1,w2 = param.w2, h = param.h,h1 = param.h1,h2 = param.h2, 
      r = param.r,r1 = param.r1, r2 = param.r2,
      gxah = param.gxah,gyah = param.gyah,gxaw = param.gxaw,gyaw = param.gyaw,
      gxch = param.gxch,gych = param.gych,gxcw = param.gxcw,gycw = param.gycw,
      gxgh = param.gxgh,gygh = param.gygh,gxgw = param.gxgw,gygw = param.gygw,
      gxih = param.gxih,gyih = param.gyih,gxiw = param.gxiw,gyiw = param.gyiw,
      cutLine=param.cutLine,cutFilletRadius=param.cutFilletRadius;
   //var myRrgGapRoundRectangle = new makerjs.models.RoundRectangle(w, h, r);
   /**new Arc(pointA: IPoint, pointB: IPoint, radius: number, largeArc: boolean, clockwise: boolean): Arc */
   var myRrgGapRoundRectangle = {
      paths: {
        "LeftBottomArc": new makerjs.paths.Arc([gxgw, gygw],[gxgh, gygh], r,false,true),
        "LeftLineArc": new makerjs.paths.Arc([gxgh, gygh], [gxah, gyah],r1,false,true),
        "LeftTopArc": new makerjs.paths.Arc([gxah, gyah], [gxaw, gyaw], r, false, true),//是否大弧,是否顺时针
        "TopLineArc": new makerjs.paths.Arc([gxaw, gyaw], [gxcw, gycw], r2, false, true),
        "RightTopArc": new makerjs.paths.Arc([gxcw, gycw], [gxch, gych], r, false, true),
        "RightLineArc": new makerjs.paths.Arc([gxch, gych], [gxih, gyih], r1, false, true),
        "RightBottomArc": new makerjs.paths.Arc([gxih, gyih], [gxiw, gyiw], r, false, true),
        "BottomLineArc": new makerjs.paths.Arc([gxiw, gyiw], [gxgw, gygw], r2, false, true),
      }
    };
   if (area == "A") {
      myRrgGapRoundRectangle.origin = [xa, ya - h];
   } else if (area == "B") {
      myRrgGapRoundRectangle.origin = [xb-w/2, yb - h];
   } else if (area == "C") {
      myRrgGapRoundRectangle.origin = [xc - w, yc - h];
   } else if (area == "D") {
      myRrgGapRoundRectangle.origin=[xd,yd-h/2]; 
   } else if (area == "E") {
      myRrgGapRoundRectangle.origin=[xe-w/2,ye-h/2];
   } else if (area == "F") {
      myRrgGapRoundRectangle.origin=[xf-w,yf-h/2];
   } else if (area == "G") {
      myRrgGapRoundRectangle.origin=[xg,yg];
   } else if (area == "H") {
      myRrgGapRoundRectangle.origin=[xh-w/2,yh]; 
   } else if (area == "I") {
      myRrgGapRoundRectangle.origin=[xi-w,yi];
   }
   return myRrgGapRoundRectangle;
};
// 矩形等去角标记 连线函数      
function creatmyRectRoundGapMarkA(outParam, area, param, inputParam, fixedParam, OffsetParam, zoom) {
   console.log("是否调用此函数creatCornerMark()");
   console.log("是否调用此函数param", param);
   console.log("是否调用此函数outParam", outParam);
   console.log("是否调用此函数inputParam", inputParam);
   console.log("是否调用此函数OffsetParam", OffsetParam);
   var H = inputParam.H,H1 = inputParam.H1,H2 = inputParam.H2, 
   R = inputParam.R, R1 = inputParam.R1, R2 = inputParam.R2, 
   W = inputParam.W,W1 = inputParam.W1,W2 = inputParam.W2, 
    X = inputParam.X, Y = inputParam.Y, myZoom = zoom * 1,
      xa = param.xa, ya = param.ya, xb = param.xb,yb = param.yb, xc = param.xc,yc = param.yc, 
      xd = param.xd, yd = param.yd, xe = param.xe, ye = param.ye, xf = param.xf, yf = param.yf,
      xg = param.xg, yg = param.yg, xh = param.xh, yh = param.yh, xi = param.xi, yi = param.yi,
      x0 = param.x0, y0 = param.y0, w = param.w,w1 = param.w1,w2 = param.w2,h = param.h,h1 = param.h1,h2 = param.h2, 
      r = param.r,r1 = param.r1,r2 = param.r2,dww1 = param.dww1,dww2 = param.dww2,dhh1 = param.dhh1,dhh2 = param.dhh2,
      
      gxah = param.gxah,gyah = param.gyah,gxaw = param.gxaw,gyaw = param.gyaw,
      gxch = param.gxch,gych = param.gych,gxcw = param.gxcw,gycw = param.gycw,
      gxgh = param.gxgh,gygh = param.gygh,gxgw = param.gxgw,gygw = param.gygw,
      gxih = param.gxih,gyih = param.gyih,gxiw = param.gxiw,gyiw = param.gyiw,
      glassW = outParam.glassW, glassH = outParam.glassH,
      markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
      markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,
      hd=0,
      w = W * 1 * myZoom,
         w1 = W1 * 1 * myZoom,
         w2 = W2 * 1 * myZoom,
         h = H * 1 * myZoom,
         h1 = H1 * 1 * myZoom,
         h2 = H2 * 1 * myZoom,
         r = R * 1 * myZoom,
         r1 = R1 * 1 * myZoom,
         r2 = R2 * 1 * myZoom,
      // w=0,w1=0,w2=0,h=0,h1=0,h2=0,r=0,r1=0,r2=0,
      x0 = X * 1 * myZoom,
      y0 = Y * 1 * myZoom;
      var arrA = [], arrC = [], arrG = [], arrI = [],rd = r / Math.sqrt(2)*1,
      arrG=Circle_Center(gxgh,gygh,gxgw,gygw,r),
          aG = arrG[0].toFixed() * 1,
          bG = arrG[1].toFixed() * 1,
          aGx=(aG-rd).toFixed()*1,
          aGy=(bG-rd).toFixed()*1,
      // arrA=Circle_Center(gxah,gyah,gxaw,gyaw,r),
      //     aA = arrA[0].toFixed() * 1,
      //     bA = arrA[1].toFixed() * 1,
      aA=aG,bA=ya-bG,
      aAx=aGx,aAy=ya-aGy,

      aC=xc-aG,bC=yc-bG,
      aCx=xc-aGx,aCy=yc-aGy,

      aI=xi-aG,bI=bG,
      aIx=xi-aGx,aIy=aGy,
///////////////////////////////
      aB=xb-w/2+aG,bB=yb-bG,
      aBx=xb-w/2+aGx,aBy=yb-aGy,

      aD=aG,bD=yd-h/2+bG,
      aDx=aGx,aDy=yd-h/2+aGy,

      aE=xe-w/2+aG,bE=ye-h/2+bG,
      aEx=xe-w/2+aGx,aEy=ye-h/2+aGy,

      aF=xf-aG,bF=yf-h/2+bG,
      aFx=xf-aGx,aFy=yf-h/2+aGy,

      aH=xh-w/2+aG,bH=yh+bG,
      aHx=xh-w/2+aGx,aHy=yh+aGy;
console.log("!!!!!!!!arrA==",arrG,aG,bG,aGx,aGy);
console.log("!!!!!!!!55555xa,ya==",xa,ya);
console.log("!!!!!!!!55555=xb,yb=",xb,yb);
console.log("!!!!!!!!55555=xc,yc=",xc,yc);
console.log("!!!!!!!!55555=xd,yd=",xd,yd);
console.log("!!!!!!!!55555=,xe,ye=",xe,ye);
console.log("!!!!!!!!55555=xf,yf=",xf,yf);
console.log("!!!!!!!!55555=xg,yg=",xg,yg);
console.log("!!!!!!!!55555=xh,yh=",xh,yh);
console.log("!!!!!!!!55555=xi,hi=",xi,yi);
if (r !== 0) {
var TxtR = "R=" + R;
}if (r1 !== 0) {
var TxtR1 = "R1=" + R1;
}if (r2 !== 0) {
var TxtR2 = "R2=" + R2;
}
if (h !== 0) {
var TxtH = H;
}
if (h1 !== 0) {
var TxtH1 = H1;
}
if (h2 !== 0) {
var TxtH2 = H2;
}
if (w !== 0) {
var TxtW = W;
}
if (w1 !== 0) {
var TxtW1 = W1;
}
if (w2 !== 0) {
var TxtW2 = W2;
}
if (x0 !== 0) {
var TxtX = X;
}
if (y0 !== 0) {
var TxtY = Y;

}
   if (area == "A") {
      var myRrgGapAMakerX = {
         paths: {
            "XALineTopTitle": new makerjs.paths.Line([xa - x0, ya], [xa, ya]),
            "XALineLeft": new makerjs.paths.Line([xa - x0, ya+ markShiftTwo], [xa - x0, ya - markShiftTwo]),
            // "XALineRight": new makerjs.paths.Line([xa, ya- markShiftTwo], [xa, ya+h/2]),
         }
      };
      var myRrgGapAMakerY = {
         paths: {
            "YALineTop": new makerjs.paths.Line([xa- markShiftTwo, ya], [xa+w/2, ya]),
            "YALineTitle": new makerjs.paths.Line([xa, ya-h/2], [xa, ya+y0]),
            "YGLineBottom": new makerjs.paths.Line([xa- markShiftTwo, ya+y0], [xa+ markShiftTwo, ya+y0]),
         }
      };
      var myRrgGapAMakerW = {
         paths: {
            "WALineLeft": new makerjs.paths.Line([xa, ya-h/2], [xa, ya-h-markShiftFour*5]),
            "WALineRight": new makerjs.paths.Line([xa+w, ya-h/2], [xa+w, ya-h-markShiftFour*5]),
            "WALineTopTitle": new makerjs.paths.Line([xa, ya-h-markShiftFour*4-markShiftTwo], [xa+w, ya-h-markShiftFour*4-markShiftTwo]),
         }
      };
      var myRrgGapAMakerW1 = {
         paths: {
            "W1ALineLeft": new makerjs.paths.Line([xa+dww1, ya-h+dhh2], [xa+dww1, ya-h-markShiftFour*4]),
            "W1ALineRight": new makerjs.paths.Line([xa+w1+dww1, ya-h+dhh2], [xa+w1+dww1, ya-h-markShiftFour*4]),
            "W1ALineTopTitle": new makerjs.paths.Line([xa+dww1, ya-h-markShiftFour*3-markShiftTwo], [xa+w1+dww1, ya-h-markShiftFour*3-markShiftTwo]),
         }
      };
      var myRrgGapAMakerW2 = {
         paths: {
            "W2ALineLeft": new makerjs.paths.Line([xa+dww2, ya-h+dhh1], [xa+dww2, ya-h-markShiftFour*3]),
            "W2ALineRight": new makerjs.paths.Line([xa+w2+dww2, ya-h+dhh1], [xa+w2+dww2, ya-h-markShiftFour*3]),
            "W2ALineTopTitle": new makerjs.paths.Line([xa+dww2, ya-h-markShiftFour*2-markShiftTwo], [xa+w2+dww2, ya-h-markShiftFour*2-markShiftTwo]),
         }
      };
      
      var myRrgGapAMakerH = {
         paths: {
            "HALineTop": new makerjs.paths.Line([xa+w/2, ya-h], [xa+w+markShiftFour*5, ya-h]),
            "HALineBottom": new makerjs.paths.Line([xa+w/2, ya],[xa+w+markShiftFour*5, ya]),
            "HALineTitle": new makerjs.paths.Line([xa+w+markShiftFour*4+markShiftTwo, ya-h], [xa+w+markShiftFour*4+markShiftTwo, ya]),
         }
      };
      var myRrgGapAMakerH1 = {
         paths: {
            "H1ALineTop": new makerjs.paths.Line([xa+w-dww2, ya-h+dhh1], [xa+w+markShiftFour*4, ya-h+dhh1]),
            "H1ALineBottom": new makerjs.paths.Line([xa+w-dww2, ya-dhh1],[xa+w+markShiftFour*4, ya-dhh1]),
            "H1ALineTitle": new makerjs.paths.Line([xa+w+markShiftFour*3+markShiftTwo, ya-h+dhh1], [xa+w+markShiftFour*3+markShiftTwo, ya-dhh1]),
         }
      };
      var myRrgGapAMakerH2 = {
         paths: {
            "H2ALineTop": new makerjs.paths.Line([xa+w-dww1, ya-h+dhh2], [xa+w+markShiftFour*3, ya-h+dhh2]),
            "H2ALineBottom": new makerjs.paths.Line([xa+w-dww1, ya-dhh2],[xa+w+markShiftFour*3, ya-dhh2]),
            "H2ALineTitle": new makerjs.paths.Line([xa+w+markShiftFour*2+markShiftTwo, ya-h+dhh2], [xa+w+markShiftFour*2+markShiftTwo, ya-dhh2]),
         }
      };
      var myRrgGapAMakerR = {
         paths: {
            "RALine0": new makerjs.paths.Line([aAx+x0,aAy], [aA+x0,bA]),
           
         }
      };
      var myRrgGapAMakerR1 = {
         paths: {
            "RALine0": new makerjs.paths.Line([xa,ya-h/2], [xa+markShiftFour*2,ya-h/2]),
           
         }
      };
      var myRrgGapAMakerR2 = {
         paths: {
            "RALine0": new makerjs.paths.Line([xa+w/2,ya-h], [xa+w/2,ya-h+markShiftFour*2]),
           
         }
      };
     makerjs.model.addCaption(myRrgGapAMakerX, TxtX, [xa - x0, ya+markShiftThree], [xa, ya+markShiftThree]);//X文字标注 
     makerjs.model.addCaption(myRrgGapAMakerY, TxtY, [xa+markShiftThree, ya], [xa+markShiftThree, ya+y0]);//Y文字标注 
     makerjs.model.addCaption(myRrgGapAMakerH,   TxtH, [xa+w+markShiftFour*4+markShiftThree, ya-h], [xa+w+markShiftFour*4+markShiftThree, ya]);//H文字标注
     makerjs.model.addCaption(myRrgGapAMakerH1, TxtH1, [xa+w+markShiftFour*3+markShiftThree, ya-h+dhh1], [xa+w+markShiftFour*3+markShiftThree, ya-dhh1]);//H1文字标注
     makerjs.model.addCaption(myRrgGapAMakerH2, TxtH2, [xa+w+markShiftFour*2+markShiftThree, ya-h+dhh2], [xa+w+markShiftFour*2+markShiftThree, ya-dhh2]);//H2文字标注
     makerjs.model.addCaption(myRrgGapAMakerW, TxtW, [xa, ya-h-markShiftFour*4-markShiftThree], [xa+w, ya-h-markShiftFour*4-markShiftThree]);//W文字标注
     makerjs.model.addCaption(myRrgGapAMakerW1, TxtW1, [xa+dww1, ya-h-markShiftFour*3-markShiftThree], [xa+w1+dww1, ya-h-markShiftFour*3-markShiftThree]);//W1文字标注  
     makerjs.model.addCaption(myRrgGapAMakerW2, TxtW2,[xa+dww2, ya-h-markShiftFour*2-markShiftThree], [xa+w2+dww2, ya-h-markShiftFour*2-markShiftThree]);//W2文字标注   
     makerjs.model.addCaption(myRrgGapAMakerR, TxtR, [aA+x0,bA], [aA+x0+markShiftFour*2,bA]);//R文字标注     
     makerjs.model.addCaption(myRrgGapAMakerR1, TxtR1, [xa+markShiftFour*2,ya-h/2], [xa+markShiftFour*4,ya-h/2]);//R文字标注     
     makerjs.model.addCaption(myRrgGapAMakerR2, TxtR2, [xa+w/2,ya-h+markShiftFour*2], [xa+w/2,ya-h+markShiftFour*4]);//R文字标注  
      var markers = [myRrgGapAMakerW,myRrgGapAMakerW1,myRrgGapAMakerW2,myRrgGapAMakerH,myRrgGapAMakerH1,myRrgGapAMakerH2,myRrgGapAMakerR,myRrgGapAMakerR1,myRrgGapAMakerR2,myRrgGapAMakerX,myRrgGapAMakerY]
   } else if (area == "B") {
      var myRrgGapBMakerX = {
         paths: {
            "XBLineTopTitle": new makerjs.paths.Line([xb - x0-w/2, yb], [xb-w/2, yb]),
            "XBLineLeft": new makerjs.paths.Line([xb - x0-w/2, yb+ markShiftTwo], [xb-w/2 - x0, yb - markShiftTwo]),
            // "XBLineRight": new makerjs.paths.Line([xb-w/2, yb- markShiftTwo], [xb-w/2, yb+h/2]),
         }
      };
      var myRrgGapBMakerY = {
         paths: {
            "YBLineTop": new makerjs.paths.Line([xb-w/2- markShiftTwo, yb], [xb, yb]),
            "YBLineTitle": new makerjs.paths.Line([xb-w/2, yb-h/2], [xb-w/2, yb+y0]),
            "YGLineBottom": new makerjs.paths.Line([xb-w/2- markShiftTwo, yb+y0], [xb-w/2+ markShiftTwo, yb+y0]),
         }
      };
      var myRrgGapBMakerW = {
         paths: {
            "WBLineLeft": new makerjs.paths.Line([xb-w/2, yb-h/2], [xb-w/2, yb-h-markShiftFour*5]),
            "WBLineRight": new makerjs.paths.Line([xb+w/2, yb-h/2], [xb+w/2, yb-h-markShiftFour*5]),
            "WBLineTopTitle": new makerjs.paths.Line([xb-w/2, yb-h-markShiftFour*4-markShiftTwo], [xb+w/2, yb-h-markShiftFour*4-markShiftTwo]),
         }
      };
      var myRrgGapBMakerW1 = {
         paths: {
            "W1BLineLeft": new makerjs.paths.Line([xb-w/2+dww1, yb-h+dhh2], [xb-w/2+dww1, yb-h-markShiftFour*4]),
            "W1BLineRight": new makerjs.paths.Line([xb-w/2+w1+dww1, yb-h+dhh2], [xb-w/2+w1+dww1, yb-h-markShiftFour*4]),
            "W1BLineTopTitle": new makerjs.paths.Line([xb-w/2+dww1, yb-h-markShiftFour*3-markShiftTwo], [xb-w/2+w1+dww1, yb-h-markShiftFour*3-markShiftTwo]),
         }
      };
      var myRrgGapBMakerW2 = {
         paths: {
            "W2BLineLeft": new makerjs.paths.Line([xb-w/2+dww2, yb-h+dhh1], [xb-w/2+dww2, yb-h-markShiftFour*3]),
            "W2BLineRight": new makerjs.paths.Line([xb-w/2+w2+dww2, yb-h+dhh1], [xb-w/2+w2+dww2, yb-h-markShiftFour*3]),
            "W2BLineTopTitle": new makerjs.paths.Line([xb-w/2+dww2, yb-h-markShiftFour*2-markShiftTwo], [xb-w/2+w2+dww2, yb-h-markShiftFour*2-markShiftTwo]),
         }
      };      
      var myRrgGapBMakerH = {
         paths: {
            "HBLineTop": new makerjs.paths.Line([xb, yb-h], [xb+w/2+markShiftFour*5, yb-h]),
            "HBLineBottom": new makerjs.paths.Line([xb, yb],[xb+w/2+markShiftFour*5, yb]),
            "HBLineTitle": new makerjs.paths.Line([xb+w/2+markShiftFour*4+markShiftTwo, yb-h], [xb+w/2+markShiftFour*4+markShiftTwo, yb]),
         }
      };
      var myRrgGapBMakerH1 = {
         paths: {
            "H1BLineTop": new makerjs.paths.Line([xb+w/2-dww2, yb-h+dhh1], [xb+w/2+markShiftFour*4, yb-h+dhh1]),
            "H1BLineBottom": new makerjs.paths.Line([xb+w/2-dww2, yb-dhh1],[xb+w/2+markShiftFour*4, yb-dhh1]),
            "H1BLineTitle": new makerjs.paths.Line([xb+w/2+markShiftFour*3+markShiftTwo, yb-h+dhh1], [xb+w/2+markShiftFour*3+markShiftTwo, yb-dhh1]),
         }
      };
      var myRrgGapBMakerH2 = {
         paths: {
            "H2BLineTop": new makerjs.paths.Line([xb+w/2-dww1, yb-h+dhh2], [xb+w/2+markShiftFour*3, yb-h+dhh2]),
            "H2BLineBottom": new makerjs.paths.Line([xb+w/2-dww1, yb-dhh2],[xb+w/2+markShiftFour*3, yb-dhh2]),
            "H2BLineTitle": new makerjs.paths.Line([xb+w/2+markShiftFour*2+markShiftTwo, yb-h+dhh2], [xb+w/2+markShiftFour*2+markShiftTwo, yb-dhh2]),
         }
      };
      var myRrgGapBMakerR = {
         paths: {
            "RBLine0": new makerjs.paths.Line([aBx,aBy], [aB,bB]),
           
         }
      };
      var myRrgGapBMakerR1 = {
         paths: {
            "RBLine0": new makerjs.paths.Line([xb-w/2,yb-h/2], [xb-w/2+markShiftFour*2,yb-h/2]),
           
         }
      };
      var myRrgGapBMakerR2 = {
         paths: {
            "RBLine0": new makerjs.paths.Line([xb,yb-h], [xb,yb-h+markShiftFour*2]),
           
         }
      };
     makerjs.model.addCaption(myRrgGapBMakerX, TxtX, [xb-w/2 - x0, yb+markShiftThree], [xb-w/2, yb+markShiftThree]);//X文字标注 
     makerjs.model.addCaption(myRrgGapBMakerY, TxtY, [xb-w/2+markShiftThree, yb], [xb-w/2+markShiftThree, yb+y0]);//Y文字标注 
     makerjs.model.addCaption(myRrgGapBMakerH,   TxtH, [xb+w/2+markShiftFour*4+markShiftThree, yb-h], [xb+w/2+markShiftFour*4+markShiftThree, yb]);//H文字标注
     makerjs.model.addCaption(myRrgGapBMakerH1, TxtH1, [xb+w/2+markShiftFour*3+markShiftThree, yb-h+dhh1], [xb+w/2+markShiftFour*3+markShiftThree, yb-dhh1]);//H1文字标注
     makerjs.model.addCaption(myRrgGapBMakerH2, TxtH2, [xb+w/2+markShiftFour*2+markShiftThree, yb-h+dhh2], [xb+w/2+markShiftFour*2+markShiftThree, yb-dhh2]);//H2文字标注
     makerjs.model.addCaption(myRrgGapBMakerW, TxtW, [xb-w/2, yb-h-markShiftFour*4-markShiftThree], [xb+w/2, yb-h-markShiftFour*4-markShiftThree]);//W文字标注
     makerjs.model.addCaption(myRrgGapBMakerW1, TxtW1, [xb-w/2+dww1, yb-h-markShiftFour*3-markShiftThree], [xb-w/2+w1+dww1, yb-h-markShiftFour*3-markShiftThree]);//W1文字标注  
     makerjs.model.addCaption(myRrgGapBMakerW2, TxtW2,[xb-w/2+dww2, yb-h-markShiftFour*2-markShiftThree], [xb-w/2+w2+dww2, yb-h-markShiftFour*2-markShiftThree]);//W2文字标注   
     makerjs.model.addCaption(myRrgGapBMakerR, TxtR,[aB,bB], [aB+markShiftFour*2,bB]);//R文字标注     
     makerjs.model.addCaption(myRrgGapBMakerR1, TxtR1, [xb-w/2+markShiftFour*2,yb-h/2], [xb-w/2+markShiftFour*4,yb-h/2]);//R文字标注     
     makerjs.model.addCaption(myRrgGapBMakerR2, TxtR2, [xb,yb-h+markShiftFour*2], [xb,yb-h+markShiftFour*4]);//R文字标注  
      var markers = [myRrgGapBMakerW,myRrgGapBMakerW1,myRrgGapBMakerW2,myRrgGapBMakerH,myRrgGapBMakerH1,myRrgGapBMakerH2,myRrgGapBMakerR,myRrgGapBMakerR1,myRrgGapBMakerR2,myRrgGapBMakerX,myRrgGapBMakerY];
   } else if (area == "C") {
      var myRrgGapCMakerX = {
         paths: {
            "XCLineTopTitle": new makerjs.paths.Line([xc + x0, yc], [xc, yc]),
            "XCLineLeft": new makerjs.paths.Line([xc + x0, yc+ markShiftTwo], [xc + x0, yc - markShiftTwo]),
            // "XCLineRight": new makerjs.paths.Line([xc, yc- markShiftTwo], [xc, yc+h/2]),
         }
      };
      var myRrgGapCMakerY = {
         paths: {
            "YCLineTop": new makerjs.paths.Line([xc+ markShiftTwo, yc], [xc-w/2, yc]),
            "YCLineTitle": new makerjs.paths.Line([xc, yc-h/2], [xc, yc+y0]),
            "YGLineBottom": new makerjs.paths.Line([xc+ markShiftTwo, yc+y0], [xc-markShiftTwo, yc+y0]),
         }
      };
      var myRrgGapCMakerW = {
         paths: {
            "WCLineLeft": new makerjs.paths.Line([xc, yc-h/2], [xc, yc-h-markShiftFour*5]),
            "WCLineRight": new makerjs.paths.Line([xc-w, yc-h/2], [xc-w, yc-h-markShiftFour*5]),
            "WCLineTopTitle": new makerjs.paths.Line([xc, yc-h-markShiftFour*4-markShiftTwo], [xc-w, yc-h-markShiftFour*4-markShiftTwo]),
         }
      };
      var myRrgGapCMakerW1 = {
         paths: {
            "W1CLineLeft": new makerjs.paths.Line([xc-dww1, yc-h+dhh2], [xc-dww1, yc-h-markShiftFour*4]),
            "W1CLineRight": new makerjs.paths.Line([xc-w1-dww1, yc-h+dhh2], [xc-w1-dww1, yc-h-markShiftFour*4]),
            "W1CLineTopTitle": new makerjs.paths.Line([xc-dww1, yc-h-markShiftFour*3-markShiftTwo], [xc-w1-dww1, yc-h-markShiftFour*3-markShiftTwo]),
         }
      };
      var myRrgGapCMakerW2 = {
         paths: {
            "W2CLineLeft": new makerjs.paths.Line([xc-dww2, yc-h+dhh1], [xc-dww2, yc-h-markShiftFour*3]),
            "W2CLineRight": new makerjs.paths.Line([xc-w2-dww2, yc-h+dhh1], [xc-w2-dww2, yc-h-markShiftFour*3]),
            "W2CLineTopTitle": new makerjs.paths.Line([xc-dww2, yc-h-markShiftFour*2-markShiftTwo], [xc-w2-dww2, yc-h-markShiftFour*2-markShiftTwo]),
         }
      };
      
      var myRrgGapCMakerH = {
         paths: {
            "HCLineTop": new makerjs.paths.Line([xc-w/2, yc-h], [xc-w-markShiftFour*5, yc-h]),
            "HCLineBottom": new makerjs.paths.Line([xc-w/2, yc],[xc-w-markShiftFour*5, yc]),
            "HCLineTitle": new makerjs.paths.Line([xc-w-markShiftFour*4-markShiftTwo, yc-h], [xc-w-markShiftFour*4-markShiftTwo, yc]),
         }
      };
      var myRrgGapCMakerH1 = {
         paths: {
            "H1CLineTop": new makerjs.paths.Line([xc-w+dww2, yc-h+dhh1], [xc-w-markShiftFour*4, yc-h+dhh1]),
            "H1CLineBottom": new makerjs.paths.Line([xc-w+dww2, yc-dhh1],[xc-w-markShiftFour*4, yc-dhh1]),
            "H1CLineTitle": new makerjs.paths.Line([xc-w-markShiftFour*3-markShiftTwo, yc-h+dhh1], [xc-w-markShiftFour*3-markShiftTwo, yc-dhh1]),
         }
      };
      var myRrgGapCMakerH2 = {
         paths: {
            "H2CLineTop": new makerjs.paths.Line([xc-w+dww1, yc-h+dhh2], [xc-w-markShiftFour*3, yc-h+dhh2]),
            "H2CLineBottom": new makerjs.paths.Line([xc-w+dww1, yc-dhh2],[xc-w-markShiftFour*3, yc-dhh2]),
            "H2CLineTitle": new makerjs.paths.Line([xc-w-markShiftFour*2-markShiftTwo, yc-h+dhh2], [xc-w-markShiftFour*2-markShiftTwo, yc-dhh2]),
         }
      };
      var myRrgGapCMakerR = {
         paths: {
            "RCLine0": new makerjs.paths.Line([aCx,aCy], [aC,bC]),
           
         }
      };
      var myRrgGapCMakerR1 = {
         paths: {
            "RCLine0": new makerjs.paths.Line([xc,yc-h/2], [xc-markShiftFour*2,yc-h/2]),
           
         }
      };
      var myRrgGapCMakerR2 = {
         paths: {
            "RCLine0": new makerjs.paths.Line([xc-w/2,yc-h], [xc-w/2,yc-h+markShiftFour*2]),
           
         }
      };
     makerjs.model.addCaption(myRrgGapCMakerX, TxtX, [xc, yc+markShiftThree], [xc+ x0, yc+markShiftThree]);//X文字标注 
     makerjs.model.addCaption(myRrgGapCMakerY, TxtY, [xc-markShiftThree, yc], [xc-markShiftThree, yc+y0]);//Y文字标注 
     makerjs.model.addCaption(myRrgGapCMakerH,   TxtH, [xc-w-markShiftFour*4-markShiftThree, yc-h], [xc-w-markShiftFour*4-markShiftThree, yc]);//H文字标注
     makerjs.model.addCaption(myRrgGapCMakerH1, TxtH1, [xc-w-markShiftFour*3-markShiftThree, yc-h+dhh1], [xc-w-markShiftFour*3-markShiftThree, yc-dhh1]);//H1文字标注
     makerjs.model.addCaption(myRrgGapCMakerH2, TxtH2, [xc-w-markShiftFour*2-markShiftThree, yc-h+dhh2], [xc-w-markShiftFour*2-markShiftThree, yc-dhh2]);//H2文字标注
     makerjs.model.addCaption(myRrgGapCMakerW, TxtW, [xc-w, yc-h-markShiftFour*4-markShiftThree], [xc, yc-h-markShiftFour*4-markShiftThree]);//W文字标注
     makerjs.model.addCaption(myRrgGapCMakerW1, TxtW1, [xc-w1-dww1, yc-h-markShiftFour*3-markShiftThree], [xc-dww1, yc-h-markShiftFour*3-markShiftThree]);//W1文字标注  
     makerjs.model.addCaption(myRrgGapCMakerW2, TxtW2,[xc-w2-dww2, yc-h-markShiftFour*2-markShiftThree], [xc-dww2, yc-h-markShiftFour*2-markShiftThree]);//W2文字标注   
     makerjs.model.addCaption(myRrgGapCMakerR, TxtR, [aC-markShiftFour*2,bC], [aC,bC]);//R文字标注     
     makerjs.model.addCaption(myRrgGapCMakerR1, TxtR1, [xc-markShiftFour*4,yc-h/2], [xc-markShiftFour*2,yc-h/2]);//R文字标注     
     makerjs.model.addCaption(myRrgGapCMakerR2, TxtR2, [xc-w/2,yc-h+markShiftFour*2], [xc-w/2,yc-h+markShiftFour*4]);//R文字标注  
      var markers = [myRrgGapCMakerW,myRrgGapCMakerW1,myRrgGapCMakerW2,myRrgGapCMakerH,myRrgGapCMakerH1,myRrgGapCMakerH2,myRrgGapCMakerR,myRrgGapCMakerR1,myRrgGapCMakerR2,myRrgGapCMakerX,myRrgGapCMakerY];
   }else if (area == "D") {
      var myRrgGapDMakerX = {
         paths: {
            "XDLineTopTitle": new makerjs.paths.Line([xd - x0, yd], [xd, yd]),
            "XDLineLeft": new makerjs.paths.Line([xd - x0, yd+ markShiftTwo], [xd - x0, yd - markShiftTwo]),
            // "XDLineRight": new makerjs.paths.Line([xd, yd- markShiftTwo], [xd, yd+h/2]),
         }
      };
      var myRrgGapDMakerY = {
         // paths: {
         //    "YDLineTop": new makerjs.paths.Line([xd- markShiftTwo, yd], [xd+w/2, yd]),
         //    "YDLineTitle": new makerjs.paths.Line([xd, yd-h/2], [xd, yd+y0]),
         //    "YGLineBottom": new makerjs.paths.Line([xd- markShiftTwo, yd+y0], [xd+ markShiftTwo, yd+y0]),
         // }
      };
      var myRrgGapDMakerW = {
         paths: {
            "WDLineLeft": new makerjs.paths.Line([xd, yd], [xd, yd-h/2-markShiftFour*5]),
            "WDLineRight": new makerjs.paths.Line([xd+w, yd], [xd+w, yd-h/2-markShiftFour*5]),
            "WDLineTopTitle": new makerjs.paths.Line([xd, yd-h/2-markShiftFour*4-markShiftTwo], [xd+w, yd-h/2-markShiftFour*4-markShiftTwo]),
         }
      };
      var myRrgGapDMakerW1 = {
         paths: {
            "W1DLineLeft": new makerjs.paths.Line([xd+dww1, yd-h/2+dhh2], [xd+dww1, yd-h/2-markShiftFour*4]),
            "W1DLineRight": new makerjs.paths.Line([xd+w1+dww1, yd-h/2+dhh2], [xd+w1+dww1, yd-h/2-markShiftFour*4]),
            "W1DLineTopTitle": new makerjs.paths.Line([xd+dww1, yd-h/2-markShiftFour*3-markShiftTwo], [xd+w1+dww1, yd-h/2-markShiftFour*3-markShiftTwo]),
         }
      };
      var myRrgGapDMakerW2 = {
         paths: {
            "W2DLineLeft": new makerjs.paths.Line([xd+dww2, yd-h/2+dhh1], [xd+dww2, yd-h/2-markShiftFour*3]),
            "W2DLineRight": new makerjs.paths.Line([xd+w2+dww2, yd-h/2+dhh1], [xd+w2+dww2, yd-h/2-markShiftFour*3]),
            "W2DLineTopTitle": new makerjs.paths.Line([xd+dww2, yd-h/2-markShiftFour*2-markShiftTwo], [xd+w2+dww2, yd-h/2-markShiftFour*2-markShiftTwo]),
         }
      };
      
      var myRrgGapDMakerH = {
         paths: {
            "HDLineTop": new makerjs.paths.Line([xd+w/2, yd-h/2], [xd+w+markShiftFour*5, yd-h/2]),
            "HDLineBottom": new makerjs.paths.Line([xd+w/2, yd+h/2],[xd+w+markShiftFour*5, yd+h/2]),
            "HDLineTitle": new makerjs.paths.Line([xd+w+markShiftFour*4+markShiftTwo, yd-h/2], [xd+w+markShiftFour*4+markShiftTwo, yd+h/2]),
         }
      };
      var myRrgGapDMakerH1 = {
         paths: {
            "H1DLineTop": new makerjs.paths.Line([xd+w-dww2, yd-h/2+dhh1], [xd+w+markShiftFour*4, yd-h/2+dhh1]),
            "H1DLineBottom": new makerjs.paths.Line([xd+w-dww2, yd+h/2-dhh1],[xd+w+markShiftFour*4, yd+h/2-dhh1]),
            "H1DLineTitle": new makerjs.paths.Line([xd+w+markShiftFour*3+markShiftTwo, yd-h/2+dhh1], [xd+w+markShiftFour*3+markShiftTwo, yd+h/2-dhh1]),
         }
      };
      var myRrgGapDMakerH2 = {
         paths: {
            "H2DLineTop": new makerjs.paths.Line([xd+w-dww1, yd-h/2+dhh2], [xd+w+markShiftFour*3, yd-h/2+dhh2]),
            "H2DLineBottom": new makerjs.paths.Line([xd+w-dww1, yd+h/2-dhh2],[xd+w+markShiftFour*3, yd+h/2-dhh2]),
            "H2DLineTitle": new makerjs.paths.Line([xd+w+markShiftFour*2+markShiftTwo, yd-h/2+dhh2], [xd+w+markShiftFour*2+markShiftTwo, yd+h/2-dhh2]),
         }
      };
      var myRrgGapDMakerR = {
         paths: {
            "RDLine0": new makerjs.paths.Line([aDx+x0,aDy], [aD+x0,bD]),
           
         }
      };
      var myRrgGapDMakerR1 = {
         paths: {
            "RDLine0": new makerjs.paths.Line([xd,yd], [xd+markShiftFour*2,yd]),
           
         }
      };
      var myRrgGapDMakerR2 = {
         paths: {
            "RDLine0": new makerjs.paths.Line([xd+w/2,yd-h/2], [xd+w/2,yd-h/2+markShiftFour*2]),
           
         }
      };
     makerjs.model.addCaption(myRrgGapDMakerX, TxtX, [xd - x0, yd+markShiftThree], [xd, yd+markShiftThree]);//X文字标注 
     makerjs.model.addCaption(myRrgGapDMakerY, TxtY, [xd+markShiftThree, yd], [xd+markShiftThree, yd+y0]);//Y文字标注 
     makerjs.model.addCaption(myRrgGapDMakerH,   TxtH, [xd+w+markShiftFour*4+markShiftThree, yd-h/2], [xd+w+markShiftFour*4+markShiftThree, yd+h/2]);//H文字标注
     makerjs.model.addCaption(myRrgGapDMakerH1, TxtH1, [xd+w+markShiftFour*3+markShiftThree, yd-h/2+dhh1], [xd+w+markShiftFour*3+markShiftThree, yd+h/2-dhh1]);//H1文字标注
     makerjs.model.addCaption(myRrgGapDMakerH2, TxtH2, [xd+w+markShiftFour*2+markShiftThree, yd-h/2+dhh2], [xd+w+markShiftFour*2+markShiftThree, yd+h/2-dhh2]);//H2文字标注
     makerjs.model.addCaption(myRrgGapDMakerW, TxtW, [xd, yd-h/2-markShiftFour*4-markShiftThree], [xd+w, yd-h/2-markShiftFour*4-markShiftThree]);//W文字标注
     makerjs.model.addCaption(myRrgGapDMakerW1, TxtW1, [xd+dww1, yd-h/2-markShiftFour*3-markShiftThree], [xd+w1+dww1, yd-h/2-markShiftFour*3-markShiftThree]);//W1文字标注  
     makerjs.model.addCaption(myRrgGapDMakerW2, TxtW2,[xd+dww2, yd-h/2-markShiftFour*2-markShiftThree], [xd+w2+dww2, yd-h/2-markShiftFour*2-markShiftThree]);//W2文字标注   
     makerjs.model.addCaption(myRrgGapDMakerR, TxtR, [aD+x0,bD], [aD+x0+markShiftFour*2,bD]);//R文字标注     
     makerjs.model.addCaption(myRrgGapDMakerR1, TxtR1, [xd+markShiftFour*2,yd-h/2+h/2], [xd+markShiftFour*4,yd-h/2+h/2]);//R文字标注     
     makerjs.model.addCaption(myRrgGapDMakerR2, TxtR2, [xd+w/2,yd-h/2+markShiftFour*2], [xd+w/2,yd-h/2+markShiftFour*4]);//R文字标注  
      var markers = [myRrgGapDMakerW,myRrgGapDMakerW1,myRrgGapDMakerW2,myRrgGapDMakerH,myRrgGapDMakerH1,myRrgGapDMakerH2,myRrgGapDMakerR,myRrgGapDMakerR1,myRrgGapDMakerR2,myRrgGapDMakerX,myRrgGapDMakerY];
   }else if (area == "E") {
      var myRrgGapEMakerX = {
         paths: {
            // "XELineTopTitle": new makerjs.paths.Line([xe - x0-w/2, ye], [xe-w/2, ye]),
            // "XELineLeft": new makerjs.paths.Line([xe - x0-w/2, ye+ markShiftTwo], [xe-w/2 - x0, ye - markShiftTwo]),
            // "XELineRight": new makerjs.paths.Line([xe-w/2, ye- markShiftTwo], [xe-w/2, ye+h/2]),
         }
      };
      var myRrgGapEMakerY = {
         paths: {
            // "YELineTop": new makerjs.paths.Line([xe-w/2- markShiftTwo, ye], [xe, ye]),
            // "YELineTitle": new makerjs.paths.Line([xe-w/2, ye-h/2], [xe-w/2, ye+y0]),
            // "YGLineBottom": new makerjs.paths.Line([xe-w/2- markShiftTwo, ye+y0], [xe-w/2+ markShiftTwo, ye+y0]),
         }
      };
      var myRrgGapEMakerW = {
         paths: {
            "WELineLeft": new makerjs.paths.Line([xe-w/2, ye], [xe-w/2, ye-h/2-markShiftFour*5]),
            "WELineRight": new makerjs.paths.Line([xe+w/2, ye], [xe+w/2, ye-h/2-markShiftFour*5]),
            "WELineTopTitle": new makerjs.paths.Line([xe-w/2, ye-h/2-markShiftFour*4-markShiftTwo], [xe+w/2, ye-h/2-markShiftFour*4-markShiftTwo]),
         }
      };
      var myRrgGapEMakerW1 = {
         paths: {
            "W1ELineLeft": new makerjs.paths.Line([xe-w/2+dww1, ye-h/2+dhh2], [xe-w/2+dww1, ye-h/2-markShiftFour*4]),
            "W1ELineRight": new makerjs.paths.Line([xe-w/2+w1+dww1, ye-h/2+dhh2], [xe-w/2+w1+dww1, ye-h/2-markShiftFour*4]),
            "W1ELineTopTitle": new makerjs.paths.Line([xe-w/2+dww1, ye-h/2-markShiftFour*3-markShiftTwo], [xe-w/2+w1+dww1, ye-h/2-markShiftFour*3-markShiftTwo]),
         }
      };
      var myRrgGapEMakerW2 = {
         paths: {
            "W2ELineLeft": new makerjs.paths.Line([xe-w/2+dww2, ye-h/2+dhh1], [xe-w/2+dww2, ye-h/2-markShiftFour*3]),
            "W2ELineRight": new makerjs.paths.Line([xe-w/2+w2+dww2, ye-h/2+dhh1], [xe-w/2+w2+dww2, ye-h/2-markShiftFour*3]),
            "W2ELineTopTitle": new makerjs.paths.Line([xe-w/2+dww2, ye-h/2-markShiftFour*2-markShiftTwo], [xe-w/2+w2+dww2, ye-h/2-markShiftFour*2-markShiftTwo]),
         }
      };      
      var myRrgGapEMakerH = {
         paths: {
            "HELineTop": new makerjs.paths.Line([xe, ye-h/2], [xe+w/2+markShiftFour*5, ye-h/2]),
            "HELineBottom": new makerjs.paths.Line([xe, ye+h/2],[xe+w/2+markShiftFour*5, ye+h/2]),
            "HELineTitle": new makerjs.paths.Line([xe+w/2+markShiftFour*4+markShiftTwo, ye-h/2], [xe+w/2+markShiftFour*4+markShiftTwo, ye+h/2]),
         }
      };
      var myRrgGapEMakerH1 = {
         paths: {
            "H1ELineTop": new makerjs.paths.Line([xe+w/2-dww2, ye-h/2+dhh1], [xe+w/2+markShiftFour*4, ye-h/2+dhh1]),
            "H1ELineBottom": new makerjs.paths.Line([xe+w/2-dww2, ye+h/2-dhh1],[xe+w/2+markShiftFour*4, ye+h/2-dhh1]),
            "H1ELineTitle": new makerjs.paths.Line([xe+w/2+markShiftFour*3+markShiftTwo, ye-h/2+dhh1], [xe+w/2+markShiftFour*3+markShiftTwo, ye+h/2-dhh1]),
         }
      };
      var myRrgGapEMakerH2 = {
         paths: {
            "H2ELineTop": new makerjs.paths.Line([xe+w/2-dww1, ye-h/2+dhh2], [xe+w/2+markShiftFour*3, ye-h/2+dhh2]),
            "H2ELineBottom": new makerjs.paths.Line([xe+w/2-dww1, ye+h/2-dhh2],[xe+w/2+markShiftFour*3, ye+h/2-dhh2]),
            "H2ELineTitle": new makerjs.paths.Line([xe+w/2+markShiftFour*2+markShiftTwo, ye-h/2+dhh2], [xe+w/2+markShiftFour*2+markShiftTwo, ye+h/2-dhh2]),
         }
      };
      var myRrgGapEMakerR = {
         paths: {
            "RELine0": new makerjs.paths.Line([aEx,aEy], [aE,bE]),
           
         }
      };
      var myRrgGapEMakerR1 = {
         paths: {
            "RELine0": new makerjs.paths.Line([xe-w/2,ye], [xe-w/2+markShiftFour*2,ye]),
           
         }
      };
      var myRrgGapEMakerR2 = {
         paths: {
            "RELine0": new makerjs.paths.Line([xe,ye-h/2], [xe,ye-h/2+markShiftFour*2]),
           
         }
      };
     makerjs.model.addCaption(myRrgGapEMakerX, TxtX, [xe-w/2 - x0, ye+markShiftThree], [xe-w/2, ye+markShiftThree]);//X文字标注 
     makerjs.model.addCaption(myRrgGapEMakerY, TxtY, [xe-w/2+markShiftThree, ye], [xe-w/2+markShiftThree, ye+y0]);//Y文字标注 
     makerjs.model.addCaption(myRrgGapEMakerH,   TxtH, [xe+w/2+markShiftFour*4+markShiftThree, ye-h/2], [xe+w/2+markShiftFour*4+markShiftThree, ye+h/2]);//H文字标注
     makerjs.model.addCaption(myRrgGapEMakerH1, TxtH1, [xe+w/2+markShiftFour*3+markShiftThree, ye-h/2+dhh1], [xe+w/2+markShiftFour*3+markShiftThree, ye+h/2-dhh1]);//H1文字标注
     makerjs.model.addCaption(myRrgGapEMakerH2, TxtH2, [xe+w/2+markShiftFour*2+markShiftThree, ye-h/2+dhh2], [xe+w/2+markShiftFour*2+markShiftThree, ye+h/2-dhh2]);//H2文字标注
     makerjs.model.addCaption(myRrgGapEMakerW, TxtW, [xe-w/2, ye-h/2-markShiftFour*4-markShiftThree], [xe+w/2, ye-h/2-markShiftFour*4-markShiftThree]);//W文字标注
     makerjs.model.addCaption(myRrgGapEMakerW1, TxtW1, [xe-w/2+dww1, ye-h/2-markShiftFour*3-markShiftThree], [xe-w/2+w1+dww1, ye-h/2-markShiftFour*3-markShiftThree]);//W1文字标注  
     makerjs.model.addCaption(myRrgGapEMakerW2, TxtW2,[xe-w/2+dww2, ye-h/2-markShiftFour*2-markShiftThree], [xe-w/2+w2+dww2, ye-h/2-markShiftFour*2-markShiftThree]);//W2文字标注   
     makerjs.model.addCaption(myRrgGapEMakerR, TxtR,[aE,bE], [aE+markShiftFour*2,bE]);//R文字标注     
     makerjs.model.addCaption(myRrgGapEMakerR1, TxtR1, [xe-w/2+markShiftFour*2,ye], [xe-w/2+markShiftFour*4,ye]);//R文字标注     
     makerjs.model.addCaption(myRrgGapEMakerR2, TxtR2, [xe,ye-h/2+markShiftFour*2], [xe,ye-h/2+markShiftFour*4]);//R文字标注  
      var markers = [myRrgGapEMakerW,myRrgGapEMakerW1,myRrgGapEMakerW2,myRrgGapEMakerH,myRrgGapEMakerH1,myRrgGapEMakerH2,myRrgGapEMakerR,myRrgGapEMakerR1,myRrgGapEMakerR2,myRrgGapEMakerX,myRrgGapEMakerY];  
  
   }else if (area == "F") {
      var myRrgGapFMakerX = {
         paths: {
            "XFLineTopTitle": new makerjs.paths.Line([xf + x0, yf], [xf, yf]),
            "XFLineLeft": new makerjs.paths.Line([xf + x0, yf+ markShiftTwo], [xf + x0, yf - markShiftTwo]),
            // "XFLineRight": new makerjs.paths.Line([xf, yf- markShiftTwo], [xf, yf+h/2]),
         }
      };
      var myRrgGapFMakerY = {
         // paths: {
         //    "YFLineTop": new makerjs.paths.Line([xf- markShiftTwo, yf], [xf+w/2, yf]),
         //    "YFLineTitle": new makerjs.paths.Line([xf, yf-h/2], [xf, yf+y0]),
         //    "YGLineBottom": new makerjs.paths.Line([xf- markShiftTwo, yf+y0], [xf+ markShiftTwo, yf+y0]),
         // }
      };
      var myRrgGapFMakerW = {
         paths: {
            "WFLineLeft": new makerjs.paths.Line([xf, yf], [xf, yf-h/2-markShiftFour*5]),
            "WFLineRight": new makerjs.paths.Line([xf-w, yf], [xf-w, yf-h/2-markShiftFour*5]),
            "WFLineTopTitle": new makerjs.paths.Line([xf, yf-h/2-markShiftFour*4-markShiftTwo], [xf-w, yf-h/2-markShiftFour*4-markShiftTwo]),
         }
      };
      var myRrgGapFMakerW1 = {
         paths: {
            "W1FLineLeft": new makerjs.paths.Line([xf-dww1, yf-h/2+dhh2], [xf-dww1, yf-h/2-markShiftFour*4]),
            "W1FLineRight": new makerjs.paths.Line([xf-w1-dww1, yf-h/2+dhh2], [xf-w1-dww1, yf-h/2-markShiftFour*4]),
            "W1FLineTopTitle": new makerjs.paths.Line([xf-dww1, yf-h/2-markShiftFour*3-markShiftTwo], [xf-w1-dww1, yf-h/2-markShiftFour*3-markShiftTwo]),
         }
      };
      var myRrgGapFMakerW2 = {
         paths: {
            "W2FLineLeft": new makerjs.paths.Line([xf-dww2, yf-h/2+dhh1], [xf-dww2, yf-h/2-markShiftFour*3]),
            "W2FLineRight": new makerjs.paths.Line([xf-w2-dww2, yf-h/2+dhh1], [xf-w2-dww2, yf-h/2-markShiftFour*3]),
            "W2FLineTopTitle": new makerjs.paths.Line([xf-dww2, yf-h/2-markShiftFour*2-markShiftTwo], [xf-w2-dww2, yf-h/2-markShiftFour*2-markShiftTwo]),
         }
      };
      
      var myRrgGapFMakerH = {
         paths: {
            "HFLineTop": new makerjs.paths.Line([xf-w/2, yf-h/2], [xf-w-markShiftFour*5, yf-h/2]),
            "HFLineBottom": new makerjs.paths.Line([xf-w/2, yf+h/2],[xf-w-markShiftFour*5, yf+h/2]),
            "HFLineTitle": new makerjs.paths.Line([xf-w-markShiftFour*4-markShiftTwo, yf-h/2], [xf-w-markShiftFour*4-markShiftTwo, yf+h/2]),
         }
      };
      var myRrgGapFMakerH1 = {
         paths: {
            "H1FLineTop": new makerjs.paths.Line([xf-w+dww2, yf-h/2+dhh1], [xf-w-markShiftFour*4, yf-h/2+dhh1]),
            "H1FLineBottom": new makerjs.paths.Line([xf-w+dww2, yf+h/2-dhh1],[xf-w-markShiftFour*4, yf+h/2-dhh1]),
            "H1FLineTitle": new makerjs.paths.Line([xf-w-markShiftFour*3-markShiftTwo, yf-h/2+dhh1], [xf-w-markShiftFour*3-markShiftTwo, yf+h/2-dhh1]),
         }
      };
      var myRrgGapFMakerH2 = {
         paths: {
            "H2FLineTop": new makerjs.paths.Line([xf-w+dww1, yf-h/2+dhh2], [xf-w-markShiftFour*3, yf-h/2+dhh2]),
            "H2FLineBottom": new makerjs.paths.Line([xf-w+dww1, yf+h/2-dhh2],[xf-w-markShiftFour*3, yf+h/2-dhh2]),
            "H2FLineTitle": new makerjs.paths.Line([xf-w-markShiftFour*2-markShiftTwo, yf-h/2+dhh2], [xf-w-markShiftFour*2-markShiftTwo, yf+h/2-dhh2]),
         }
      };
      var myRrgGapFMakerR = {
         paths: {
            "RFLine0": new makerjs.paths.Line([aFx,aFy], [aF,bF]),
           
         }
      };
      var myRrgGapFMakerR1 = {
         paths: {
            "RFLine0": new makerjs.paths.Line([xf,yf], [xf-markShiftFour*2,yf]),
           
         }
      };
      var myRrgGapFMakerR2 = {
         paths: {
            "RFLine0": new makerjs.paths.Line([xf-w/2,yf-h/2], [xf-w/2,yf-h/2+markShiftFour*2]),
           
         }
      };
     makerjs.model.addCaption(myRrgGapFMakerX, TxtX, [xf, yf+markShiftThree], [xf + x0, yf+markShiftThree]);//X文字标注 
     makerjs.model.addCaption(myRrgGapFMakerY, TxtY, [xf-markShiftThree, yf], [xf-markShiftThree, yf+y0]);//Y文字标注 
     makerjs.model.addCaption(myRrgGapFMakerH,   TxtH, [xf-w-markShiftFour*4-markShiftThree, yf-h/2], [xf-w-markShiftFour*4-markShiftThree, yf+h/2]);//H文字标注
     makerjs.model.addCaption(myRrgGapFMakerH1, TxtH1, [xf-w-markShiftFour*3-markShiftThree, yf-h/2+dhh1], [xf-w-markShiftFour*3-markShiftThree, yf+h/2-dhh1]);//H1文字标注
     makerjs.model.addCaption(myRrgGapFMakerH2, TxtH2, [xf-w-markShiftFour*2-markShiftThree, yf-h/2+dhh2], [xf-w-markShiftFour*2-markShiftThree, yf+h/2-dhh2]);//H2文字标注
     makerjs.model.addCaption(myRrgGapFMakerW, TxtW,   [xf-w, yf-h/2-markShiftFour*4-markShiftThree], [xf, yf-h/2-markShiftFour*4-markShiftThree]);//W文字标注
     makerjs.model.addCaption(myRrgGapFMakerW1, TxtW1, [xf-w1-dww1, yf-h/2-markShiftFour*3-markShiftThree], [xf-dww1, yf-h/2-markShiftFour*3-markShiftThree]);//W1文字标注  
     makerjs.model.addCaption(myRrgGapFMakerW2, TxtW2, [xf-w2-dww2, yf-h/2-markShiftFour*2-markShiftThree],[xf-dww2, yf-h/2-markShiftFour*2-markShiftThree]);//W2文字标注   
     makerjs.model.addCaption(myRrgGapFMakerR, TxtR,   [aF-markShiftFour*2,bF], [aF,bF]);//R文字标注     
     makerjs.model.addCaption(myRrgGapFMakerR1, TxtR1, [xf-markShiftFour*4,yf-h/2+h/2], [xf-markShiftFour*2,yf-h/2+h/2]);//R文字标注     
     makerjs.model.addCaption(myRrgGapFMakerR2, TxtR2, [xf-w/2,yf-h/2+markShiftFour*2], [xf-w/2,yf-h/2+markShiftFour*4]);//R文字标注  
      var markers = [myRrgGapFMakerW,myRrgGapFMakerW1,myRrgGapFMakerW2,myRrgGapFMakerH,myRrgGapFMakerH1,myRrgGapFMakerH2,myRrgGapFMakerR,myRrgGapFMakerR1,myRrgGapFMakerR2,myRrgGapFMakerX,myRrgGapFMakerY];
   } else if (area == "G") {
      var myRrgGapGMakerX = {
         paths: {
            "XGLineTopTitle": new makerjs.paths.Line([xg - x0, yg], [xg, yg]),
            "XGLineLeft": new makerjs.paths.Line([xg - x0, yg+ markShiftTwo], [xg - x0, yg - markShiftTwo]),
             "XGLineRight": new makerjs.paths.Line([xg, yg- markShiftTwo], [xg, yg+h/2]),
         }
      };
      var myRrgGapGMakerY = {
         paths: {
            "YALineTop": new makerjs.paths.Line([xg- markShiftTwo, yg], [xg+w/2, yg]),
            "YALineTitle": new makerjs.paths.Line([xg, yg], [xg, yg-y0]),
            "YGLineBottom": new makerjs.paths.Line([xg- markShiftTwo, yg-y0], [xg+ markShiftTwo, yg-y0]),
         }
      };
      var myRrgGapGMakerW = {
         paths: {
            "WGLineLeft": new makerjs.paths.Line([xg, yg+h/2], [xg, yg+h+markShiftFour*5]),
            "WGLineRight": new makerjs.paths.Line([xg+w, yg+h/2], [xg+w, yg+h+markShiftFour*5]),
            "WGLineTopTitle": new makerjs.paths.Line([xg, yg+h+markShiftFour*4+markShiftTwo], [xg+w, yg+h+markShiftFour*4+markShiftTwo]),
         }
      };
      var myRrgGapGMakerW1 = {
         paths: {
            "W1GLineLeft": new makerjs.paths.Line([xg+dww1, yg+h-dhh2], [xg+dww1, yg+h+markShiftFour*4]),
            "W1GLineRight": new makerjs.paths.Line([xg+w1+dww1, yg+h-dhh2], [xg+w1+dww1, yg+h+markShiftFour*4]),
            "W1GLineTopTitle": new makerjs.paths.Line([xg+dww1, yg+h+markShiftFour*3+markShiftTwo], [xg+w1+dww1, yg+h+markShiftFour*3+markShiftTwo]),
         }
      };
      var myRrgGapGMakerW2 = {
         paths: {
            "W2GLineLeft": new makerjs.paths.Line([xg+dww2, yg+h-dhh1], [xg+dww2, yg+h+markShiftFour*3]),
            "W2GLineRight": new makerjs.paths.Line([xg+w2+dww2, yg+h-dhh1], [xg+w2+dww2, yg+h+markShiftFour*3]),
            "W2GLineTopTitle": new makerjs.paths.Line([xg+dww2, yg+h+markShiftFour*2+markShiftTwo], [xg+w2+dww2, yg+h+markShiftFour*2+markShiftTwo]),
         }
      };
      // var myRrgGapGMakerW1 = {
      //    paths: {
      //       "W1GLine0": new makerjs.paths.Line([gxah, gyah], [gxah, ya+markShiftFour*5]),
      //       "W1GLine1": new makerjs.paths.Line([gxch, gych], [gxch, yc+markShiftFour*5]),
      //       "W1GLine2": new makerjs.paths.Line([gxah, ya+markShiftFour*4+markShiftTwo], [gxch, yc+markShiftFour*4+markShiftTwo]),
      //    }
      // };
      // var myRrgGapGMakerW2 = {
      //    paths: {
      //       "W2GLine0": new makerjs.paths.Line([gxaw, gyaw], [gxaw, ya+markShiftFour*4]),
      //       "W2GLine1": new makerjs.paths.Line([gxcw, gycw], [gxcw, yc+markShiftFour*4]),
      //       "W2GLine2": new makerjs.paths.Line([gxaw, ya+markShiftFour*3+markShiftTwo], [gxcw, yc+markShiftFour*3+markShiftTwo]),
      //    }
      // };
      // var myRrgGapGMakerH = {
      //    paths: {
      //       "HGLine0": new makerjs.paths.Line([xb, yb], [xc+markShiftFour*5, yb]),
      //       "HGLine1": new makerjs.paths.Line([xh, yh],[xi+markShiftFour*5, yh]),
      //       "HGLine2": new makerjs.paths.Line([xc+markShiftFour*4+markShiftTwo, yb], [xi+markShiftFour*4+markShiftTwo, yh]),
      //    }
      // };
      var myRrgGapGMakerH = {
         paths: {
            "HGLineTop": new makerjs.paths.Line([xg+w/2, yg+h], [xg+w+markShiftFour*5, yg+h]),
            "HGLineBottom": new makerjs.paths.Line([xg+w/2, yg],[xg+w+markShiftFour*5, yg]),
            "HGLineTitle": new makerjs.paths.Line([xg+w+markShiftFour*4+markShiftTwo, yg+h], [xg+w+markShiftFour*4+markShiftTwo, yg]),
         }
      };
      // var myRrgGapGMakerH1 = {
      //    paths: {
      //       "H1GLine0": new makerjs.paths.Line([gxcw, gycw], [xc+markShiftFour*4, gycw]),
      //       "H1GLine1": new makerjs.paths.Line([gxiw, gyiw], [xi+markShiftFour*4, gyiw]),
      //       "H1GLine2": new makerjs.paths.Line([xc+markShiftFour*3+markShiftTwo, gycw],[xi+markShiftFour*3+markShiftTwo, gyiw]),
      //    }
      // };
      var myRrgGapGMakerH1 = {
         paths: {
            "H1GLineTop": new makerjs.paths.Line([xg+w-dww2, yg+h-dhh1], [xg+w+markShiftFour*4, yg+h-dhh1]),
            "H1GLineBottom": new makerjs.paths.Line([xg+w-dww2, yg+dhh1],[xg+w+markShiftFour*4, yg+dhh1]),
            "H1GLineTitle": new makerjs.paths.Line([xg+w+markShiftFour*3+markShiftTwo, yg+h-dhh1], [xg+w+markShiftFour*3+markShiftTwo, yg+dhh1]),
         }
      };
      // var myRrgGapGMakerH2 = {
      //    paths: {
      //       "H2GLine0": new makerjs.paths.Line([gxch, gych], [xc+markShiftFour*3, gych]),
      //       "H2GLine1": new makerjs.paths.Line([gxih, gyih], [xi+markShiftFour*3, gyih]),
      //       "H2GLine2": new makerjs.paths.Line([xc+markShiftFour*2+markShiftTwo, gych],[xi+markShiftFour*2+markShiftTwo, gyih]),
      //    }
      // };
      var myRrgGapGMakerH2 = {
         paths: {
            "H2GLineTop": new makerjs.paths.Line([xg+w-dww1, yg+h-dhh2], [xg+w+markShiftFour*3, yg+h-dhh2]),
            "H2GLineBottom": new makerjs.paths.Line([xg+w-dww1, yg+dhh2],[xg+w+markShiftFour*3, yg+dhh2]),
            "H2GLineTitle": new makerjs.paths.Line([xg+w+markShiftFour*2+markShiftTwo, yg+h-dhh2], [xg+w+markShiftFour*2+markShiftTwo, yg+dhh2]),
         }
      };
      // var myRrgGapGMakerR = {
      //    paths: {
      //       "RGLine0": new makerjs.paths.Line([aGx,aGy], [aG,bG]),
           
      //    }
      // };
      var myRrgGapGMakerR = {
         paths: {
            "RGLine0": new makerjs.paths.Line([aGx+x0,aGy+y0], [aG+x0,bG+y0]),
           
         }
      };
      var myRrgGapGMakerR1 = {
         paths: {
            "RGLine0": new makerjs.paths.Line([xg,yg+h/2], [xg+markShiftFour*2,yg+h/2]),
           
         }
      };
      var myRrgGapGMakerR2 = {
         paths: {
            "RGLine0": new makerjs.paths.Line([xg+w/2,yg+h], [xg+w/2,yg+h-markShiftFour*2]),
           
         }
      };
     makerjs.model.addCaption(myRrgGapGMakerX, TxtX, [xg - x0, yg+markShiftThree], [xg, yg+markShiftThree]);//X文字标注 
     makerjs.model.addCaption(myRrgGapGMakerY, TxtY, [xg+markShiftThree, yg], [xg+markShiftThree, yg-y0]);//Y文字标注 
     makerjs.model.addCaption(myRrgGapGMakerH,   TxtH, [xg+w+markShiftFour*4+markShiftThree, yg+h], [xg+w+markShiftFour*4+markShiftThree, yg]);//H文字标注
     makerjs.model.addCaption(myRrgGapGMakerH1, TxtH1, [xg+w+markShiftFour*3+markShiftThree, yg+h-dhh1], [xg+w+markShiftFour*3+markShiftThree, yg+dhh1]);//H1文字标注
     makerjs.model.addCaption(myRrgGapGMakerH2, TxtH2, [xg+w+markShiftFour*2+markShiftThree, yg+h-dhh2], [xg+w+markShiftFour*2+markShiftThree, yg+dhh2]);//H2文字标注
     makerjs.model.addCaption(myRrgGapGMakerW, TxtW, [xg, yg+h+markShiftFour*4+markShiftThree], [xg+w, yg+h+markShiftFour*4+markShiftThree]);//W文字标注
     makerjs.model.addCaption(myRrgGapGMakerW1, TxtW1, [xg+dww1, yg+h+markShiftFour*3+markShiftThree], [xg+w1+dww1, yg+h+markShiftFour*3+markShiftThree]);//W1文字标注  
     makerjs.model.addCaption(myRrgGapGMakerW2, TxtW2,[xg+dww2, yg+h+markShiftFour*2+markShiftThree], [xg+w2+dww2, yg+h+markShiftFour*2+markShiftThree]);//W2文字标注   
     makerjs.model.addCaption(myRrgGapGMakerR, TxtR, [aG+x0,bG+y0], [aG+x0+markShiftFour*2,bG+y0]);//R文字标注     
     makerjs.model.addCaption(myRrgGapGMakerR1, TxtR1, [xg+markShiftFour*2,yg+h/2], [xg+markShiftFour*4,yg+h/2]);//R文字标注     
     makerjs.model.addCaption(myRrgGapGMakerR2, TxtR2, [xg+w/2,yg+h-markShiftFour*2], [xg+w/2,yg+h-markShiftFour*4]);//R文字标注  
      var markers = [myRrgGapGMakerW,myRrgGapGMakerW1,myRrgGapGMakerW2,myRrgGapGMakerH,myRrgGapGMakerH1,myRrgGapGMakerH2,myRrgGapGMakerR,myRrgGapGMakerR1,myRrgGapGMakerR2,myRrgGapGMakerX,myRrgGapGMakerY]   
   } else if (area == "H") {
      var myRrgGapHMakerX = {
         paths: {
            "XHLineTopTitle": new makerjs.paths.Line([xh - x0-w/2, yh], [xh-w/2, yh]),
            "XHLineLeft": new makerjs.paths.Line([xh - x0-w/2, yh- markShiftTwo], [xh-w/2 - x0, yh + markShiftTwo]),
            // "XHLineRight": new makerjs.paths.Line([xh-w/2, yh+ markShiftTwo], [xh-w/2, yh-h/2]),
         }
      };
       var myRrgGapHMakerY = {
         paths: {
            "YHLineTop": new makerjs.paths.Line([xh-w/2- markShiftTwo, yh], [xh, yh]),
            "YHLineTitle": new makerjs.paths.Line([xh-w/2, yh+h/2], [xh-w/2, yh-y0]),
            "YGLineBottom": new makerjs.paths.Line([xh-w/2- markShiftTwo, yh-y0], [xh-w/2+ markShiftTwo, yh-y0]),
         }
      };
      var myRrgGapHMakerW = {
         paths: {
            "WHLineLeft": new makerjs.paths.Line([xh-w/2, yh+h/2], [xh-w/2, yh+h+markShiftFour*5]),
            "WHLineRight": new makerjs.paths.Line([xh+w/2, yh+h/2], [xh+w/2, yh+h+markShiftFour*5]),
            "WHLineTopTitle": new makerjs.paths.Line([xh-w/2, yh+h+markShiftFour*4+markShiftTwo], [xh+w/2, yh+h+markShiftFour*4+markShiftTwo]),
         }
      };
      var myRrgGapHMakerW1 = {
         paths: {
            "W1HLineLeft": new makerjs.paths.Line([xh-w/2+dww1, yh+h-dhh2], [xh-w/2+dww1, yh+h+markShiftFour*4]),
            "W1HLineRight": new makerjs.paths.Line([xh-w/2+w1+dww1, yh+h-dhh2], [xh-w/2+w1+dww1, yh+h+markShiftFour*4]),
            "W1HLineTopTitle": new makerjs.paths.Line([xh-w/2+dww1, yh+h+markShiftFour*3+markShiftTwo], [xh-w/2+w1+dww1, yh+h+markShiftFour*3+markShiftTwo]),
         }
      };
      var myRrgGapHMakerW2 = {
         paths: {
            "W2HLineLeft": new makerjs.paths.Line([xh-w/2+dww2, yh+h-dhh1], [xh-w/2+dww2, yh+h+markShiftFour*3]),
            "W2HLineRight": new makerjs.paths.Line([xh-w/2+w2+dww2, yh+h-dhh1], [xh-w/2+w2+dww2, yh+h+markShiftFour*3]),
            "W2HLineTopTitle": new makerjs.paths.Line([xh-w/2+dww2, yh+h+markShiftFour*2+markShiftTwo], [xh-w/2+w2+dww2, yh+h+markShiftFour*2+markShiftTwo]),
         }
      };      
      var myRrgGapHMakerH = {
         paths: {
            "HHLineTop": new makerjs.paths.Line([xh, yh+h], [xh+w/2+markShiftFour*5, yh+h]),
            "HHLineBottom": new makerjs.paths.Line([xh, yh],[xh+w/2+markShiftFour*5, yh]),
            "HHLineTitle": new makerjs.paths.Line([xh+w/2+markShiftFour*4+markShiftTwo, yh+h], [xh+w/2+markShiftFour*4+markShiftTwo, yh]),
         }
      };
      var myRrgGapHMakerH1 = {
         paths: {
            "H1HLineTop": new makerjs.paths.Line([xh+w/2-dww2, yh+h-dhh1], [xh+w/2+markShiftFour*4, yh+h-dhh1]),
            "H1HLineBottom": new makerjs.paths.Line([xh+w/2-dww2, yh+dhh1],[xh+w/2+markShiftFour*4, yh+dhh1]),
            "H1HLineTitle": new makerjs.paths.Line([xh+w/2+markShiftFour*3+markShiftTwo, yh+h-dhh1], [xh+w/2+markShiftFour*3+markShiftTwo, yh+dhh1]),
         }
      };
      var myRrgGapHMakerH2 = {
         paths: {
            "H2HLineTop": new makerjs.paths.Line([xh+w/2-dww1, yh+h-dhh2], [xh+w/2+markShiftFour*3, yh+h-dhh2]),
            "H2HLineBottom": new makerjs.paths.Line([xh+w/2-dww1, yh+dhh2],[xh+w/2+markShiftFour*3, yh+dhh2]),
            "H2HLineTitle": new makerjs.paths.Line([xh+w/2+markShiftFour*2+markShiftTwo, yh+h-dhh2], [xh+w/2+markShiftFour*2+markShiftTwo, yh+dhh2]),
         }
      };
      var myRrgGapHMakerR = {
         paths: {
            "RHLine0": new makerjs.paths.Line([aHx,aHy], [aH,bH]),
           
         }
      };
      var myRrgGapHMakerR1 = {
         paths: {
            "RHLine0": new makerjs.paths.Line([xh-w/2,yh+h/2], [xh-w/2+markShiftFour*2,yh+h/2]),
           
         }
      };
      var myRrgGapHMakerR2 = {
         paths: {
            "RHLine0": new makerjs.paths.Line([xh,yh+h], [xh,yh+h-markShiftFour*2]),
           
         }
      };
     makerjs.model.addCaption(myRrgGapHMakerX, TxtX, [xh-w/2 - x0, yh-markShiftThree], [xh-w/2, yh-markShiftThree]);//X文字标注 
     makerjs.model.addCaption(myRrgGapHMakerY, TxtY, [xh-w/2+markShiftThree, yh-y0], [xh-w/2+markShiftThree, yh]);//Y文字标注 
     makerjs.model.addCaption(myRrgGapHMakerH,   TxtH, [xh+w/2+markShiftFour*4+markShiftThree, yh], [xh+w/2+markShiftFour*4+markShiftThree, yh+h]);//H文字标注
     makerjs.model.addCaption(myRrgGapHMakerH1, TxtH1, [xh+w/2+markShiftFour*3+markShiftThree, yh+dhh1], [xh+w/2+markShiftFour*3+markShiftThree, yh+h-dhh1]);//H1文字标注
     makerjs.model.addCaption(myRrgGapHMakerH2, TxtH2, [xh+w/2+markShiftFour*2+markShiftThree, yh+dhh2], [xh+w/2+markShiftFour*2+markShiftThree, yh+h-dhh2]);//H2文字标注
     makerjs.model.addCaption(myRrgGapHMakerW, TxtW, [xh-w/2, yh+h+markShiftFour*4+markShiftThree], [xh+w/2, yh+h+markShiftFour*4+markShiftThree]);//W文字标注
     makerjs.model.addCaption(myRrgGapHMakerW1, TxtW1, [xh-w/2+dww1, yh+h+markShiftFour*3+markShiftThree], [xh-w/2+w1+dww1, yh+h+markShiftFour*3+markShiftThree]);//W1文字标注  
     makerjs.model.addCaption(myRrgGapHMakerW2, TxtW2,[xh-w/2+dww2, yh+h+markShiftFour*2+markShiftThree], [xh-w/2+w2+dww2, yh+h+markShiftFour*2+markShiftThree]);//W2文字标注   
     makerjs.model.addCaption(myRrgGapHMakerR, TxtR,[aH,bH], [aH+markShiftFour*2,bH]);//R文字标注     
     makerjs.model.addCaption(myRrgGapHMakerR1, TxtR1, [xh-w/2+markShiftFour*2,yh+h/2], [xh-w/2+markShiftFour*4,yh+h/2]);//R文字标注     
     makerjs.model.addCaption(myRrgGapHMakerR2, TxtR2, [xh,yh+h-markShiftFour*2], [xh,yh+h-markShiftFour*4]);//R文字标注  
      var markers = [myRrgGapHMakerW,myRrgGapHMakerW1,myRrgGapHMakerW2,myRrgGapHMakerH,myRrgGapHMakerH1,myRrgGapHMakerH2,myRrgGapHMakerR,myRrgGapHMakerR1,myRrgGapHMakerR2,myRrgGapHMakerX,myRrgGapHMakerY]
   } else if (area == "I") {
      var myRrgGapIMakerX = {
         paths: {
            "XILineTopTitle": new makerjs.paths.Line([xi+ x0, yi], [xi, yi]),
            "XILineLeft": new makerjs.paths.Line([xi+ x0, yi+ markShiftTwo], [xi+ x0, yi - markShiftTwo]),
            "XILineRight": new makerjs.paths.Line([xi, yi- markShiftTwo], [xi, yi+h/2]),
         }
      };
      var myRrgGapIMakerY = {
         paths: {
            "YILineTop": new makerjs.paths.Line([xi+ markShiftTwo, yi], [xi-w/2, yi]),
            "YILineTitle": new makerjs.paths.Line([xi, yi], [xi, yi-y0]),
            "YILineBottom": new makerjs.paths.Line([xi+markShiftTwo, yi-y0], [xi- markShiftTwo, yi-y0]),
         }
      };
      var myRrgGapIMakerW = {
         paths: {
            "WILineLeft": new makerjs.paths.Line([xi, yi+h/2], [xi, yi+h+markShiftFour*5]),
            "WILineRight": new makerjs.paths.Line([xi-w, yi+h/2], [xi-w, yi+h+markShiftFour*5]),
            "WILineTopTitle": new makerjs.paths.Line([xi, yi+h+markShiftFour*4+markShiftTwo], [xi-w, yi+h+markShiftFour*4+markShiftTwo]),
         }
      };
      var myRrgGapIMakerW1 = {
         paths: {
            "W1ILineLeft": new makerjs.paths.Line([xi-dww1, yi+h-dhh2], [xi-dww1, yi+h+markShiftFour*4]),
            "W1ILineRight": new makerjs.paths.Line([xi-w1-dww1, yi+h-dhh2], [xi-w1-dww1, yi+h+markShiftFour*4]),
            "W1ILineTopTitle": new makerjs.paths.Line([xi-dww1, yi+h+markShiftFour*3+markShiftTwo], [xi-w1-dww1, yi+h+markShiftFour*3+markShiftTwo]),
         }
      };
      var myRrgGapIMakerW2 = {
         paths: {
            "W2ILineLeft": new makerjs.paths.Line([xi-dww2, yi+h-dhh1], [xi-dww2, yi+h+markShiftFour*3]),
            "W2ILineRight": new makerjs.paths.Line([xi-w2-dww2, yi+h-dhh1], [xi-w2-dww2, yi+h+markShiftFour*3]),
            "W2ILineTopTitle": new makerjs.paths.Line([xi-dww2, yi+h+markShiftFour*2+markShiftTwo], [xi-w2-dww2, yi+h+markShiftFour*2+markShiftTwo]),
         }
      };
      var myRrgGapIMakerH = {
         paths: {
            "HILineTop": new makerjs.paths.Line([xi-w/2, yi+h], [xi-w-markShiftFour*5, yi+h]),
            "HILineBottom": new makerjs.paths.Line([xi-w/2, yi],[xi-w-markShiftFour*5, yi]),
            "HILineTitle": new makerjs.paths.Line([xi-w-markShiftFour*4-markShiftTwo, yi+h], [xi-w-markShiftFour*4-markShiftTwo, yi]),
         }
      };
      var myRrgGapIMakerH1 = {
         paths: {
            "H1ILineTop": new makerjs.paths.Line([xi-w+dww2, yi+h-dhh1], [xi-w-markShiftFour*4, yi+h-dhh1]),
            "H1ILineBottom": new makerjs.paths.Line([xi-w+dww2, yi+dhh1],[xi-w-markShiftFour*4, yi+dhh1]),
            "H1ILineTitle": new makerjs.paths.Line([xi-w-markShiftFour*3-markShiftTwo, yi+h-dhh1], [xi-w-markShiftFour*3-markShiftTwo, yi+dhh1]),
         }
      };
      var myRrgGapIMakerH2 = {
         paths: {
            "H2ILineTop": new makerjs.paths.Line([xi-w+dww1, yi+h-dhh2], [xi-w-markShiftFour*3, yi+h-dhh2]),
            "H2ILineBottom": new makerjs.paths.Line([xi-w+dww1, yi+dhh2],[xi-w-markShiftFour*3, yi+dhh2]),
            "H2ILineTitle": new makerjs.paths.Line([xi-w-markShiftFour*2-markShiftTwo, yi+h-dhh2], [xi-w-markShiftFour*2-markShiftTwo, yi+dhh2]),
         }
      };
      var myRrgGapIMakerR = {
         paths: {
            "RILine0": new makerjs.paths.Line([aIx,aIy+y0], [aI,bI+y0]),
           
         }
      };
      var myRrgGapIMakerR1 = {
         paths: {
            "RILine0": new makerjs.paths.Line([xi,yi+h/2], [xi-markShiftFour*2,yi+h/2]),
           
         }
      };
      var myRrgGapIMakerR2 = {
         paths: {
            "RILine0": new makerjs.paths.Line([xi-w/2,yi+h], [xi-w/2,yi+h-markShiftFour*2]),
           
         }
      };
     makerjs.model.addCaption(myRrgGapIMakerX, TxtX, [xi, yi+markShiftThree], [xi+ x0, yi+markShiftThree]);//X文字标注 
     makerjs.model.addCaption(myRrgGapIMakerY, TxtY, [xi-markShiftThree, yi], [xi-markShiftThree, yi-y0]);//Y文字标注 
     makerjs.model.addCaption(myRrgGapIMakerH,   TxtH, [xi-w-markShiftFour*4-markShiftThree, yi+h], [xi-w-markShiftFour*4-markShiftThree, yi]);//H文字标注
     makerjs.model.addCaption(myRrgGapIMakerH1, TxtH1, [xi-w-markShiftFour*3-markShiftThree, yi+h-dhh1], [xi-w-markShiftFour*3-markShiftThree, yi+dhh1]);//H1文字标注
     makerjs.model.addCaption(myRrgGapIMakerH2, TxtH2, [xi-w-markShiftFour*2-markShiftThree, yi+h-dhh2], [xi-w-markShiftFour*2-markShiftThree, yi+dhh2]);//H2文字标注
     makerjs.model.addCaption(myRrgGapIMakerW, TxtW, [xi-w, yi+h+markShiftFour*4+markShiftThree], [xi, yi+h+markShiftFour*4+markShiftThree]);//W文字标注
     makerjs.model.addCaption(myRrgGapIMakerW1, TxtW1, [xi-w1-dww1, yi+h+markShiftFour*3+markShiftThree], [xi-dww1, yi+h+markShiftFour*3+markShiftThree]);//W1文字标注  
     makerjs.model.addCaption(myRrgGapIMakerW2, TxtW2,[xi-w2-dww2, yi+h+markShiftFour*2+markShiftThree], [xi-dww2, yi+h+markShiftFour*2+markShiftThree]);//W2文字标注   
     makerjs.model.addCaption(myRrgGapIMakerR, TxtR, [aI-markShiftFour*2,bI+y0], [aI,bI+y0]);//R文字标注     
     makerjs.model.addCaption(myRrgGapIMakerR1, TxtR1, [xi-markShiftFour*4,yi+h/2], [xi-markShiftFour*2,yi+h/2]);//R1文字标注     
     makerjs.model.addCaption(myRrgGapIMakerR2, TxtR2, [xi-w/2,yi+h-markShiftFour*2], [xi-w/2,yi+h-markShiftFour*4]);//R2文字标注  
      var markers = [myRrgGapIMakerW,myRrgGapIMakerW1,myRrgGapIMakerW2,myRrgGapIMakerH,myRrgGapIMakerH1,myRrgGapIMakerH2,myRrgGapIMakerR,myRrgGapIMakerR1,myRrgGapIMakerR2,myRrgGapIMakerX,myRrgGapIMakerY] 
   }
   console.log("markers||||||||||||||||||=", markers)
   return markers;
};
// inputParam,model,myHolesNum,outParam,fixedParam
// (D,X,Y,area,plate,markers,myHolesNum,glassW,glassH,markShift,markShiftTwo,markShiftThree,markShiftFour,markHolesOneD)
function RectRoundGapA(inputParam, model, myHolesNum, outParam, fixedParam, zoom, θCut, rCut,cutLine,cutFilletRadius) {
    console.log("矩形圆角缺ARectRoundGapA==");
   var frame = outParam.shapeName;
   console.log("outParam==", outParam)
   console.log("model==", model)
   console.log("inputParam==", inputParam)
   console.log("outParam.shapeName==////////", outParam.shapeName)
   if (typeof (frame) == "undefined") {
      var H = inputParam.H,H1 = inputParam.H1,H2 = inputParam.H2, 
          R = inputParam.R, R1 = inputParam.R1, R2 = inputParam.R2, 
          W = inputParam.W,W1 = inputParam.W1,W2 = inputParam.W2, 
          X = inputParam.X, Y = inputParam.Y, area = inputParam.area, myZoom = zoom * 1, myθCut = θCut, myrCut = rCut,
         plate = model.plate, cutPlate = model.cutPlate, markers = model.markers, frame = "Rectangle",
         glassW = outParam.glassW, glassH = outParam.glassH,cutLine=cutLine*1,cutFilletRadius=cutFilletRadius*1,
         markShift = fixedParam.markShift, markShiftTwo = fixedParam.markShiftTwo,
         markShiftThree = fixedParam.markShiftThree, markShiftFour = fixedParam.markShiftFour, markHolesOneD = fixedParam.markHolesOneD,
         w = W * 1 * myZoom,
         w1 = W1 * 1 * myZoom,
         w2 = W2 * 1 * myZoom,
         h = H * 1 * myZoom,
         h1 = H1 * 1 * myZoom,
         h2 = H2 * 1 * myZoom,
         r = R * 1 * myZoom,
         r1 = R1 * 1 * myZoom,
         r2 = R2 * 1 * myZoom,
         
         x0 = X * 1 * myZoom,
         y0 = Y * 1 * myZoom;
         if(plate.models===undefined||plate.models===""){
            console.log("1111111111111111");
            plate.models={};
                    }        
                    if(cutPlate.models===undefined||cutPlate.models===""){
                        console.log("22222222222");
                        //cutPlate.models={};
                        cutPlate.models={};
                    }
                    if(markers.models===undefined||markers.models===""){            
                        console.log("333333333333");
                        markers.models={};
                    }
                    if (r !== 0) {
                     var TxtR = "R=" + R;
                  }if (r1 !== 0) {
                     var TxtR1 = "R1=" + R1;
                  }if (r2 !== 0) {
                     var TxtR2 = "R2=" + R2;
                  }
      if (h !== 0) {
         var TxtH = H;
      }
      if (h1 !== 0) {
         var TxtH1 = H1;
      }
      if (h2 !== 0) {
         var TxtH2 = H2;
      }
      if (w !== 0) {
         var TxtW = W;
      }
      if (w1 !== 0) {
         var TxtW1 = W1;
      }
      if (w2 !== 0) {
         var TxtW2 = W2;
      }
      if (x0 !== 0) {
         var TxtX = X;
      }
      if (y0 !== 0) {
         var TxtY = Y;
      }

   } else {
      var H = inputParam.H,H1 = inputParam.H1,H2 = inputParam.H2, 
          R = inputParam.R, R1 = inputParam.R1, R2 = inputParam.R2, 
          W = inputParam.W,W1 = inputParam.W1,W2 = inputParam.W2, 
          X = inputParam.X, Y = inputParam.Y, area = inputParam.area, myZoom = zoom * 1, myθCut = θCut, myrCut = rCut,
         plate = model.plate, cutPlate = model.cutPlate, markers = model.markers,  frame = outParam.shapeName,
         glassW = outParam.glassW, glassH = outParam.glassH,cutLine=cutLine*1,cutFilletRadius=cutFilletRadius*1,
         markShift = fixedParam.markShift, markShiftTwo = fixedParam.markShiftTwo,
         markShiftThree = fixedParam.markShiftThree, markShiftFour = fixedParam.markShiftFour, markHolesOneD = fixedParam.markHolesOneD,
         w = W * 1 * myZoom,
         w1 = W1 * 1 * myZoom,
         w2 = W2 * 1 * myZoom,
         h = H * 1 * myZoom,
         h1 = H1 * 1 * myZoom,
         h2 = H2 * 1 * myZoom,
         r = R * 1 * myZoom,
         r1 = R1 * 1 * myZoom,
         r2 = R2 * 1 * myZoom,
         
         x0 = X * 1 * myZoom,
         y0 = Y * 1 * myZoom;
         if(plate.models===undefined||plate.models===""){
            console.log("1111111111111111");
            plate.models={};
                    }        
                    if(cutPlate.models===undefined||cutPlate.models===""){
                        console.log("22222222222");
                        //cutPlate.models={};
                        cutPlate.models={};
                    }
                    if(markers.models===undefined||markers.models===""){            
                        console.log("333333333333");
                        markers.models={};
                    }
                    if (r !== 0) {
                     var TxtR = "R=" + R;
                  }if (r1 !== 0) {
                     var TxtR1 = "R1=" + R1;
                  }if (r2 !== 0) {
                     var TxtR2 = "R2=" + R2;
                  }
      if (h !== 0) {
         var TxtH = H;
      }
      if (h1 !== 0) {
         var TxtH1 = H1;
      }
      if (h2 !== 0) {
         var TxtH2 = H2;
      }
      if (w !== 0) {
         var TxtW = W;
      }
      if (w1 !== 0) {
         var TxtW1 = W1;
      }
      if (w2 !== 0) {
         var TxtW2 = W2;
      }
      if (x0 !== 0) {
         var TxtX = X;
      }
      if (y0 !== 0) {
         var TxtY = Y;
      }

   }
   if (frame == "Rectangle") {
      console.log("frame==undefined||||*****")
      var dww2=(w-w2)/2,dww1=(w-w1)/2,dhh1=(h-h1)/2,dhh2=(h-h2)/2,
     //在A区域 计算孔的位置       
  xa=x0,ya=glassH * 1-y0,

  //B区域//只有Y标注没有X标注 
  xb=glassW * 1/2,yb=glassH * 1-y0,

  //C区域
  xc=glassW * 1-x0,yc=glassH * 1-y0,
  //D区域
  //只有X标注没有Y标注 
  xd=x0,yd=glassH * 1/2,
  //E区域
  //只有X标注没有Y标注 
  xe=glassW * 1/2,ye=glassH * 1/2,
  //F区域
  //只有X标注没有Y标注 
  xf=glassW * 1-x0,yf=glassH * 1/2,
  //在G区域 计算孔的位置
  xg=x0,yg=y0,
  //在H区域 计算孔的位置
  //只标注Y
  xh=glassW * 1/2,yh=y0,
  //在I区域 计算孔的位置
  xi=glassW*1-x0,yi=y0,
  

  gxaw=dww2,gyaw=h-dhh1,
  gxah=dww1,gyah=h-dhh2,

  gxcw=w-dww2,gycw=h-dhh1,
  gxch=w-dww1,gych=h-dhh2,

  gxgw=dww2,gygw=dhh1,
  gxgh=dww1,gygh=dhh2,

  gxiw=w-dww2,gyiw=dhh1,
  gxih=w-dww1,gyih=dhh2;
  
  console.log("frame==undefined||||*****",dww1,dww2,dhh1,dhh2)
      var OffsetParam = {};
   } else if (frame == "IsoscelesTrapezoid") {

   } else if (frame == "RightAngledTrapezoid") {


   } else if (frame == "OtherTrapezoidsA") {

   } else if (frame == "OtherTrapezoidsB") {

   } else if (frame == "ParallelogramA") {


   } else if (frame == "ParallelogramB") {

   }
   // 坐标参数
   var paramCoordinate = { x0, y0, w,w1,w2,h,h1,h2, r,cutLine,cutFilletRadius,r1,r2,dww1,dww2,dhh1,dhh2,gxah,gxaw,gxch,gxcw,gxgh,gxgw,gxih,gxiw,gyah,gyaw,gych,gycw,gygh,gygw,gyih,gyiw, xa, ya, xb, yb, xc, yc,xd, yd,xe, ye,xf, yf, xg, yg, xh, yh, xi, yi };
  console.log("paramCoordinate圆角矩形坐标参数==",paramCoordinate);
   const allKeys = Object.getOwnPropertyNames(JSON.parse(JSON.stringify(model.plate.models)));
   var areaPoint = "";
   console.log("//圆角矩形 ------", allKeys)
   if (allKeys[0] == frame) {
      allKeys.shift();//去掉数组第一个元素
   }
   console.log("//缺5、圆角矩形 位置去掉数组第一个元素------", allKeys)
   switch (area) {
      case "1": areaPoint = "A"; break;
      case "2": areaPoint = "B"; break;
      case "3": areaPoint = "C"; break;
      case "4": areaPoint = "D"; break;
      case "5": areaPoint = "E"; break;
      case "6": areaPoint = "F"; break;
      case "7": areaPoint = "G"; break;
      case "8": areaPoint = "H"; break;
      case "9": areaPoint = "I"; break;
   }
   /**
   * 画图
   * 
   */
   var ObjName = "myRectRoundGap" + areaPoint;
   var ObjNameMmyRectRoundGap = "myRectRoundGap" + areaPoint + "Mark";//角标记
   ObjName = creatmyRectRoundGapA(areaPoint, paramCoordinate);//图形
   console.log("ObjName===|||||||||", ObjName);
   ObjNameMmyRectRoundGap = creatmyRectRoundGapMarkA(outParam, areaPoint, paramCoordinate, inputParam, fixedParam, OffsetParam, zoom);//图形
   console.log("ObjNameMmyRectRoundGap===|||||||||角标注", ObjNameMmyRectRoundGap);
   console.log("cutPlate.models====************", cutPlate.models),
      console.log("plate.models====**************", plate.models),
      console.log("markers.models====*************", markers.models),
      // myRrgGapGMakerW,myRrgGapGMakerW1,myRrgGapGMakerW2,myRrgGapGMakerH,myRrgGapGMakerH1,myRrgGapGMakerH2,myRrgGapGMakerR,myRrgGapGMakerR1,myRrgGapGMakerR2,myRrgGapGMakerX,myRrgGapGMakerY
      // cutPlate.models = {};
      // plate.models = {};
      // markers.models = {};
      cutPlate.models["TypeGapes_myRectRoundGap" + areaPoint + myHolesNum] = ObjName;
   plate.models["TypeGapes_myRectRoundGap" + areaPoint + myHolesNum] = ObjName;
    markers.models["TypeGapes_myRectRoundGap" + areaPoint + myHolesNum] = ObjName;
   markers.models["TypeGapes_myRrgGapGMakerW" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyRectRoundGap[0];
   markers.models["TypeGapes_myRrgGapGMakerW1" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyRectRoundGap[1];
   markers.models["TypeGapes_myRrgGapGMakerW2" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyRectRoundGap[2];
   markers.models["TypeGapes_myRrgGapGMakerH" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyRectRoundGap[3];
   markers.models["TypeGapes_myRrgGapGMakerH1" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyRectRoundGap[4];
   markers.models["TypeGapes_myRrgGapGMakerH2" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyRectRoundGap[5];
   markers.models["TypeGapes_myRrgGapGMakerR" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyRectRoundGap[6];
   markers.models["TypeGapes_myRrgGapGMakerR1" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyRectRoundGap[7];
   markers.models["TypeGapes_myRrgGapGMakerR2" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyRectRoundGap[8];
   markers.models["TypeGapes_myRrgGapGMakerX" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyRectRoundGap[9];
   markers.models["TypeGapes_myRrgGapGMakerY" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyRectRoundGap[10];

   console.log("cutPlate.models==2222==************", cutPlate.models),
      console.log("plate.models==2222==**************", plate.models),
   myHolesNum++;
   return { plate, cutPlate, markers, myHolesNum }
};


export default RectRoundGapA;